// @flow
import React from 'react';
import Header from '../../components/header';
import Form from '../../components/form';
import Table from '../../components/table';
import Overview from '../../components/overview';
import Placeholder from '../../components/placeholder';
import Disclaimer from '../../components/disclaimer';
import classnames from 'classnames';
import calculate from '../../utils/calculate';
import './styles.css';

// Type definitions
import type {OverviewItem, Simulation, FormData} from '../../utils/types';

type State = {
  type: ?('personal' | 'commercial'),
  amount: ?number,
  duration: ?number,
  submitted: boolean
};

export default class App extends React.Component<{}, State> {
  state = {
    type: null,
    amount: null,
    duration: null,
    submitted: false
  };

  // Form autocomplete for testing purposes only, not good for production
  // componentWillMount() {
  //   this.setState({
  //     type: 'commercial',
  //     amount: 100000,
  //     duration: 4,
  //     submitted: true
  //   });
  // }

  handleSubmit(formData: FormData) {
    this.setState({
      ...formData,
      submitted: true
    });
  }

  renderRightPanel() {
    const {type, amount, duration, submitted} = this.state;
    const simulation: Simulation = calculate(type, amount, duration);
    const className = classnames('App__right-column', {
      'App__right-column--results': this.state.submitted
    });

    if (submitted) {
      const items: Array<OverviewItem> = [
        { title: 'Monto Solicitado', value: simulation.stats.amount },
        { title: 'Devengamientos', value: simulation.stats.accrued },
        { title: 'Sistema', value: simulation.stats.type },
        { title: 'Plazo', value: simulation.stats.duration },
        { title: 'T.E.M.', value: simulation.stats.monthlyInterestRate },
        { title: 'T.N.A.', value: simulation.stats.nominalInterestRate },
        { title: 'Gastos Adm.', value: simulation.stats.admin },
        { title: 'Seguro', value: simulation.stats.insurance },
        { title: 'Sellado Provincial', value: simulation.stats.stateTax },
        { title: 'Recibirá por Caja', value: simulation.stats.actual },
        { title: 'Cuota Promedio', value: simulation.stats.averagePayment },
        { title: 'Total', value: simulation.stats.total }
      ];

      return (
        <section className={className}>
          <h2 className="App__subheading">Resumen</h2>
          <Overview items={items} />

          <h2 className="App__subheading">Detalle de Cuotas</h2>
          <Table rows={simulation.rows} />
        </section>
      );
    } else {
      return (
        <section className={className}>
          <Placeholder />
        </section>
      )
    }
  }

  render() {
    return (
      <section>
        <Header displayPrintButton={this.state.submitted} />

        <div className="App">
          <Form className="App__left-column" handleSubmit={this.handleSubmit.bind(this)} />

          {this.renderRightPanel()}
        </div>

        <Disclaimer />
      </section>
    );
  }
}
